import React, { lazy, Suspense } from 'react';
import CacheRoute, { CacheSwitch } from 'react-router-cache-route';
import { BrowserRouter, Route } from 'react-router-dom';
import App from 'src/components/app';
import Auth from 'src/components/auth';
import Tab from 'src/components/tab';
import bridge from 'src/utils/bridge';
import { ActivityIndicator, Loading } from 'zarm';
import expressRoute from './express/route';
import goodsRoutes from './goods/route';
import addressRoutes from './myaddress/route';
import orderRoutes from './order/route';
import staticRoutes from './static/route';
import prescriptionRoutes from './prescription/route';
import activityRoutes from './activity/route';
import myRightsRoutes from './myRights/route';
import specialRoutes from './special/route';
import transferRoutes from './transfer/route';
import cooperationRoutes from './cooperation/route';
import serviceOrderRoutes from './serviceOrder/route';

export interface routersTypes {
  path: string;
  name: string;
  component: any;
  needLogin?: boolean;
  exact?: boolean;
  title?: string;
  realAuth?: boolean;
  shouldTab?: boolean;
  keepAlive?: boolean;
}

const NotFoundPage: routersTypes = { path: '*', name: 'NotPage', component: () => import('./noPage'), title: '404' };

const routers: routersTypes[] = [
  {
    path: '/noPage',
    name: 'Home',
    component: () => import(/* webpackPrefetch: true */ './noPage'),
    needLogin: false,
    exact: true,
    title: '',
  },
  {
    path: '/w/:key',
    name: 'Home',
    component: () => import(/* webpackPrefetch: true */ './home'),
    needLogin: false,
    exact: true,
    title: '',
  },
  {
    path: '/:key',
    name: 'Home',
    component: () => import(/* webpackPrefetch: true */ './home'),
    needLogin: false,
    exact: true,
    title: '',
    shouldTab: true,
    keepAlive: true,
  },
  {
    path: '/',
    name: 'Home',
    component: () => import(/* webpackPrefetch: true */ './noPage'),
    needLogin: false,
    exact: true,
    title: '',
  },
];

const Routes = () => (
  <BrowserRouter>
    <App>
      <CacheSwitch>
        {[...routers, NotFoundPage].map((item, index) => {
          const SingleDynamicComponent = lazy(() => item.component());
          return (
            <Route
              key={index}
              path={item.path}
              exact={item.exact || false}
              render={(props: any) => {
                bridge.setTitle(item.title ? item.title : document.title);
                return (
                  <Suspense fallback={<Loading content={<ActivityIndicator />} />}>
                    <SingleDynamicComponent {...props} />
                  </Suspense>
                );
              }}
            />
          );
        })}
      </CacheSwitch>
    </App>
  </BrowserRouter>
);

// export default hot(module)(Routes);
export default Routes;
